import { observer } from 'mobx-react-lite'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'
import { EnterNumberCommon } from 'pages/settings/ui/EnterNumberCommon'

export const EnterNumber = observer(() => {
  const { enterNumberStore, nextClickHandler } = useTextEnableLandlineStepsContext()

  return <EnterNumberCommon store={enterNumberStore} nextClickHandler={nextClickHandler} />
})
